/* Header logo swap: wordmark at the top of the page, cat once scrolling.

   blocks/_header-logo.liquid already renders both logos and swaps them in
   CSS, but only off
     #header-component[data-sticky-state='active']
   or
     #header-component[sticky='always']:not([data-scroll-direction='none'])
   and with the header set to sticky ALWAYS neither of those ever flips --
   data-scroll-direction stays 'none', so the default logo showed at the top
   AND while scrolling. This supplies the one bit of state the theme never
   changes: data-irr-scrolled on <html>, read by irr-header.css.

   Nothing else keys off this attribute; it is only the logo. rAF-throttled,
   and it only writes when the state actually changes, so scrolling costs
   nothing. */
(function(){
  var root = document.documentElement;
  var on = null;
  var queued = false;

  function apply(){
    queued = false;
    var y = window.scrollY || window.pageYOffset || 0;
    var next = y > 8;
    if(next === on)return;
    on = next;
    if(on){ root.setAttribute('data-irr-scrolled',''); }
    else{ root.removeAttribute('data-irr-scrolled'); }
  }

  function schedule(){
    if(queued)return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  /* Reloading part-way down a page, and the theme editor re-rendering a
     section, both need the state set without a scroll event. */
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  apply();
})();
